import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ApplicationPaths } from '../../constants/authorization/api-authorization.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeInterceptor implements HttpInterceptor {
    constructor(private authorize: AuthorizeService, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authorize.accessToken$
      .pipe(mergeMap(token => this.processRequestWithToken(token, req, next)));
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string | null, req: HttpRequest<any>, next: HttpHandler) {
      //DBW This is ultimatley calling the token refresh

      if (!this._isAuthRequest(req)) {
          this.authorize.triggerRefreshToken = true;
      }
       //DBW This intercepts the HTTP call before it is actually made
    if (!!token && this._isSameOriginUrl(req)) {
      req = req.clone({
          setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      
    }

    return next.handle(req).pipe(catchError(x => this.handleAuthError(x)));
  }


    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        //handle your auth error or rethrow
        if (err.status === 401 || err.status === 403) {
            // Force a logout.
            this.router.navigateByUrl(ApplicationPaths.LogOut);
            // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
            return of(err.message); // or EMPTY may be appropriate here
        }
        return throwError(err);
    }



  private _isSameOriginUrl(req: any) {

    // It's an absolute url with the same origin as REST services.
    if (req.url.startsWith(`${environment.apiUrl}/`)) {
        return true;
    }

    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }

  private _isAuthRequest(req: any) {

    if(req.url.includes('api/user/refresh-token')) {
        return true;
    }
    else if (req.url.includes('api/user/revoke-token')) {
        return true;
    }
    else if (req.url.includes('api/user/authenticate')) {
        return true;
    }

    return false;
}



}
